import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { CredibilitySection } from './components/CredibilitySection';
import { SocialProofSection } from './components/SocialProofSection';
import { CuratorSection } from './components/CuratorSection';
import { DifferenceSection } from './components/DifferenceSection';
import { PricingSection } from './components/PricingSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="bg-gray-50 w-full min-h-screen" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <CredibilitySection data-id="element-4" />
      <SocialProofSection data-id="element-5" />
      <CuratorSection data-id="element-6" />
      <DifferenceSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <CTASection data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}